// extracted by mini-css-extract-plugin
export default {"tournament-tab":"PawnBrokerTabs_tournament-tab__71hX8"};